import { QueryTuple, useLazyQuery } from '@apollo/client';
import { LOAD_WELD_PROCEDURES } from '@bechtel/client-gql';
import { WeldProcedure } from '@bechtel/types';

export function useWeldProcedures(
  fetchFromNetwork?: boolean
): QueryTuple<{ loadWeldProcedures: WeldProcedure[] }, Record<string, any>> {
  const response = useLazyQuery<{ loadWeldProcedures: WeldProcedure[] }>(
    LOAD_WELD_PROCEDURES,
    fetchFromNetwork
      ? {
          notifyOnNetworkStatusChange: true,
          fetchPolicy: 'network-only',
        }
      : {
          notifyOnNetworkStatusChange: true,
        }
  );
  return response;
}
